<template>
  <div class="commin_aside">
    <div class="nav_list">
      <div class="nav_item" v-for="(item, index) in navList" :key="'nav'+index" @click="goAnchor(item.id, index)">
        <div class="icon" :class="{'divider':index === activeIndex}">
          <el-divider direction="vertical"></el-divider>
        </div>
        <span class="title" style="cursor:pointer"
              :style="{'color':index === activeIndex ? 'var(--theme-color)': '#212121'}">{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommonAside",
  props: {
    navList: Array,
    asideActive: Number
  },
  data() {
    return {
      activeIndex: 0,
    }
  },
  mounted() {
    console.log(this.navList)
  },
  methods: {
    goAnchor(compId, index) {
      this.activeIndex = index;
      this.$emit("goAnchor", compId);
    },
  },
  watch: {
    asideActive: function () {
      this.activeIndex = this.asideActive;
    },
    navList: function (val) {
      console.log(this.navList)
    }
  }
}
</script>

<style lang="less">

.commin_aside {
  text-align: left;
  background: #FFFFFF;
  height: 100%;
  padding-top: 15px;
  padding-left: 5px;

  .nav_list {
    display: flex;
    flex-direction: column;

    .nav_item {
      display: flex;
      align-items: center;

      .icon {
        width: 15px;

        .el-divider--vertical {
          height: 2.5em;
        }
      }

      .divider {
        .el-divider {
          background-color: var(--theme-color);
        }
      }

      .title {
        font-size: 12px;
        color: #212121;
        letter-spacing: 0;
        line-height: 18px;
        font-weight: 400;
        padding: 5px 10px 5px 5px;
      }
    }
  }
}
</style>
